import styled from "styled-components";
import { pinkHover, pinkHoverLight } from "../../../styles/app_colors";

export const Container = styled.div``;

export const Spin = styled.div`
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  width: 50px;
  height: 50px;
  border: 3px solid ${pinkHover}; /* Light grey */
  border-top: 3px solid ${pinkHoverLight}; /* Black */
  border-radius: 50%;
  animation: spinner 1.5s linear infinite;
`;
